





































import G_080_KojoDekidakaEntry_ChildActionsBtn from '@/components/G_kaigai/G_080_KojoDekidakaEntry_ChildActionsBtn.vue';
import { getDefaultPagerInfo } from '@/utils/utils';
import Vue from 'vue';

export default Vue.extend<any, any, any, any>({
  name: 'G_080_KojoDekidakaEntry_Table',
  components: {
    G_080_KojoDekidakaEntry_ChildActionsBtn,
  },
  props: {
    search: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    headers: [
      {
        text: '品目ｺｰﾄﾞ',
        value: 'himmokuCd',
        width: 100,
        sortable: true,
      },
      {
        text: '品目',
        value: 'himmokuMei',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        width: 450,
        sortable: true,
      },
      {
        text: '製造日',
        value: 'seizoYmdDisp',
        width: 100,
        sortable: true,
      },
      {
        text: '出来高数',
        value: 'dekidakaSuryo',
        width: 100,
        sortable: true,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '賞味期限',
        value: 'shomiKigenYmdDisp',
        width: 100,
        sortable: true,
      },
      { text: '', value: 'action', sortable: false, width: 80 },
    ],
    footerProps: {},
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
  }),
  computed: {
    tableHeight() {
      return this.$vuetify.breakpoint.height - 370;
    },
  },
  methods: {
    customSearch(_value: any, search: string | null, item: any) {
      const filterValues = [
        item['himmokuCd'],
        item['himmokuMei'],
        item['seizoYmdDisp'],
        item['dekidakaSuryo'],
        item['shomiKigenYmdDisp'],
      ];

      return filterValues.some(
        (v: any) =>
          v &&
          v
            .toString()
            .toLowerCase()
            .includes(search ? search.toLowerCase() : '')
      );
    },
  },
  mounted() {
    const pagerInfo = getDefaultPagerInfo();
    this.footerProps = pagerInfo.footerProps;
    this.options.itemsPerPage = pagerInfo.itemPerPage;
  },
});
